import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import Login from '../components/Login';
import LoadingIndicator from '../components/LoadingIndicator';

const LoginPage = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingIndicator />;
  }

  // If user is already authenticated, redirect to home
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div>
      <Login />
    </div>
  );
};

export default LoginPage;
